import React, { useState } from 'react'
import { Typography, Button, Avatar, Card, Flex } from 'antd'
import {
  UserOutlined,
  RobotOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  LoadingOutlined
} from '@ant-design/icons'

const { Text } = Typography

const MessageBubble = ({ role, text, thinking, inThinking, thinkingDone }) => {
  const isUser = role === 'user'
  const [collapsed, setCollapsed] = useState(true)
  const hasThinking = !!thinking

  if (isUser) {
    return (
      <Flex gap={12} justify="end" align="start" style={{ marginBottom: '16px' }}>
        <div
          style={{
            background: '#ad0270',
            color: '#ffffff',
            borderRadius: '18px 18px 4px 18px',
            padding: '12px 16px',
            maxWidth: '70%',
            wordBreak: 'break-word',
            fontSize: '15px',
            lineHeight: '1.4'
          }}
        >
          {text}
        </div>
        <Avatar
          size="small"
          icon={<UserOutlined />}
          style={{
            background: '#ad0270',
            flexShrink: 0,
            marginTop: '2px'
          }}
        />
      </Flex>
    )
  }

  return (
    <Flex gap={12} justify="start" align="start" style={{ marginBottom: '16px' }}>
      <Avatar
        size="small"
        icon={<RobotOutlined />}
        style={{
          background: '#6366f1',
          flexShrink: 0,
          marginTop: '2px'
        }}
      />
      <div style={{ flex: 1, maxWidth: '85%' }}>
        {/* Thinking indicator */}
        {inThinking && (
          <div
            style={{
              background: '#f1f5f9',
              border: '1px solid #e2e8f0',
              borderRadius: '18px 18px 18px 4px',
              padding: '12px 16px',
              marginBottom: text ? '8px' : 0,
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <LoadingOutlined style={{ color: '#ad0270', fontSize: '14px' }} />
            <Text
              style={{
                color: '#64748b',
                fontSize: '14px',
                fontStyle: 'italic'
              }}
            >
              Thinking...
            </Text>
          </div>
        )}

        {/* Main message content */}
        {text && (
          <div
            style={{
              background: '#f8fafc',
              border: '1px solid #e2e8f0',
              borderRadius: '18px 18px 18px 4px',
              padding: '12px 16px',
              fontSize: '15px',
              lineHeight: '1.4',
              color: '#1f2937'
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: text }} />
          </div>
        )}

        {/* Show reasoning button */}
        {!inThinking && thinkingDone && hasThinking && collapsed && (
          <div style={{ marginTop: '8px' }}>
            <Button
              type="text"
              size="small"
              icon={<EyeOutlined />}
              onClick={() => setCollapsed(false)}
              style={{
                color: '#ad0270',
                fontSize: '12px',
                height: 'auto',
                padding: '2px 6px',
                border: '1px solid #e5e7eb',
                borderRadius: '6px',
                background: '#ffffff'
              }}
            >
              Show reasoning
            </Button>
          </div>
        )}

        {/* Reasoning content */}
        {!inThinking && thinkingDone && hasThinking && !collapsed && (
          <Card
            size="small"
            style={{
              marginTop: '8px',
              background: '#fafafa',
              border: '1px solid #e5e7eb',
              borderRadius: '8px'
            }}
            styles={{
              header: {
                background: '#f5f5f5',
                borderBottom: '1px solid #e5e7eb',
                padding: '6px 12px',
                minHeight: 'auto'
              },
              body: {
                padding: '8px 12px',
                background: '#fafafa'
              }
            }}
            title={
              <Flex justify="space-between" align="center">
                <Text
                  style={{
                    color: '#374151',
                    fontWeight: 600,
                    fontSize: '12px'
                  }}
                >
                  Claude's reasoning
                </Text>
                <Button
                  type="text"
                  size="small"
                  icon={<EyeInvisibleOutlined />}
                  onClick={() => setCollapsed(true)}
                  style={{
                    color: '#6b7280',
                    padding: '2px 6px',
                    height: 'auto',
                    fontSize: '11px'
                  }}
                >
                  Hide
                </Button>
              </Flex>
            }
          >
            <pre
              style={{
                whiteSpace: 'pre-wrap',
                fontFamily: 'ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace',
                fontSize: '11px',
                lineHeight: '1.4',
                color: '#4b5563',
                margin: 0,
                background: 'transparent'
              }}
            >
              {thinking}
            </pre>
          </Card>
        )}
      </div>
    </Flex>
  )
}

export default MessageBubble